package com.dignicate.web.ui.components

import androidx.compose.runtime.Composable
import com.dignicate.web.domain.HeroContent
import com.dignicate.web.style.HeroStyles
import com.dignicate.web.theme.LocalDarkMode
import com.dignicate.web.ui.layout.Breakpoint
import com.dignicate.web.ui.layout.rememberBreakpoint
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.backgroundColor
import org.jetbrains.compose.web.css.color
import org.jetbrains.compose.web.css.padding
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Section
import org.jetbrains.compose.web.dom.Text

@Composable
fun HeroSection(content: HeroContent) {
    val isDark = LocalDarkMode.current
    val breakpoint = rememberBreakpoint()

    Section(attrs = {
        id("hero")
        classes(HeroStyles.section)
        style {
            backgroundColor(if (isDark) Color.black else Color.white)
            color(if (isDark) Color.white else Color.black)
            padding(80.px)
        }
    }) {
        val innerClass = if (breakpoint == Breakpoint.Mobile) HeroStyles.mobileInner else HeroStyles.inner

        Div({ classes(innerClass) }) {
            // Left: text column
            Div({ classes(HeroStyles.textColumn) }) {
                H1({ classes(if (breakpoint == Breakpoint.Mobile) HeroStyles.mobileTitle else HeroStyles.title) }) {
                    Text(content.title)
                }

                P({ classes(HeroStyles.subtitle) }) {
                    Text(content.subtitle)
                }
            }

            // Right: visual column (hidden on mobile)
            if (breakpoint != Breakpoint.Mobile) {
                Div({ classes(HeroStyles.visualColumn) }) {
                    // reserved visual space (placeholder)
                }
            }
        }
    }
}
